<template>
  <div>
    <div class="sd-ms-room">
      <div class="left baseTree">
        <el-tree
          show-checkbox
          :expand-on-click-node="false"
          :data="Listdata"
          default-expand-all
          node-key="title"
          ref="tree"
          highlight-current
          :props="defaultProps"
        >
        </el-tree>
      </div>
      <div class="right base-form-div">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item label="报文内容" prop="content">
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 4 }"
              placeholder="请输入报文内容"
              v-model="ruleForm.content"
            ></el-input>
          </el-form-item>
        </el-form>
        <div class="div-check">
          <el-checkbox-group v-model="checkList">
            <el-checkbox label="发送消息"></el-checkbox>
            <el-checkbox label="紧急通知"></el-checkbox>
            <el-checkbox label="修改航线"></el-checkbox>
          </el-checkbox-group>
        </div>
      </div>
    </div>
    <div class="form-bottom">
      <el-button
        class="base-button"
        size="mini"
        type="primary"
        @click="submitForm('ruleForm')"
        >发送</el-button
      >
    </div>
  </div>
</template>
<script>
import { iViewTreeDeviceGroup, getZTreeGroupDevice } from "@/api/device/index.js";
//明文：
//{"receiveCardNumbers":["666666","1859807","460228"],"content":"111"}
export default {
  props: ["subData"],
  data() {
    return {
      checkList: [],
      ruleForm: {
        receiveCardNumbers: undefined,
        content: "",
      },
      rules: {
        content: [{ required: true, message: "请输入报文内容", trigger: "blur" }],
      },

      Listdata: [],
      defaultProps: {
        children: "children",
        label: "name",
      },
      allCards: [],
    };
  },
  methods: {
    getCheck() {
      //Device_123456
      var nodes = this.$refs["tree"].getCheckedNodes(true, false);
      nodes = nodes.filter((node) => {
        return node.model && node.model.split("_")[0] == "Device";
      });
      var cards = nodes.map((n) => {
        return n.model.split("_")[1];
      });
      return cards;
    },
    submitForm(formName) {
      var nodes = this.getCheck();
      if (nodes.length < 1) {
        this.$message({
          message: "请选择接收方卡号",
          type: "error",
        });
        return;
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$message({
            message: "发送成功",
            type: "success",
          });
          this.ruleForm.receiveCardNumbers = nodes;
          console.log(this.ruleForm);
          this.$bus.$emit("sendMsg-CM", this.ruleForm);
          this.$parent.close();
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    getTree() {
      getZTreeGroupDevice()
        .then((res) => {
          var list = res.result || [];
          this.Listdata = list;
        })
        .catch((e) => {
          console.error(e);
        });
    },
  },
  created() {
    this.getTree();
  },
  mounted() {},
};
</script>

<style lang="scss">
.sd-ms-room {
  display: flex;
  height: 180px;

  .left {
    width: 40%;
    border-right: #3ab0e3 solid 1px;
    padding-right: 10px;
    height: 100%;
    overflow-y: auto;
  }

  .right {
    width: 60%;
    height: 100%;
  }
}

.form-bottom {
  margin-bottom: 0 !important;
  text-align: center;
}

.el-input-number {
  width: 100%;
}
.div-check{
    padding: 0 40px;
}
</style>
